import React from 'react';
import {PageStatus} from "../../enums";
import {RedemptionModeAPI} from "../../API";
import {Show} from "../../Layout";
import {Alert, Modal, Spinner} from "react-bootstrap";
import { myIpData } from 'Helper/EncryptionDecryption';

class ManualApproval extends React.Component<any, any> {
    constructor(props) {
        super(props);
        this.state = {
            status: PageStatus.None,
            error: null,
            coupon: '',
            pin: '',
            validity: '',
            errorMessage: '',
            successMessage: '',
        };
    }

    handleManualApprove = () => {
        let obj = {
            id: this.props.id,
            coupon: this.state.coupon ? myIpData(this.state.coupon) : "",
            approvedById: this.props.userId,
            pin: this.state.pin,
            validity: this.state.validity,
            otp: this.props.otp, 
            adminflag:"auth"
        }
        return Promise.resolve()
            .then(() => this.setState({status: PageStatus.Submitting}))
            .then(() => RedemptionModeAPI.manualApproved(obj))
            .then((res) => {
                alert('Request Approved')
                this.setState({status: PageStatus.Submitted}, () => {
                    this.props.onSubmit()
                })
            })
            .catch((error) => {
                this.setState({status: PageStatus.Error, error: error.message});
            });
    }

    render() {
        return (
            <Modal
                centered
                size="sm"
                backdrop="static"
                onHide={this.props.onClose}
                show={this.props.show}
                style={{ zIndex: 1201 }}
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        Manual Approval
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ maxHeight: '78vh', overflow: 'auto' }}>
                    <div>
                        <div>
                            <label htmlFor="title">Enter Coupon</label>
                            <input
                                className="form-control"
                                type='text'
                                name="coupon"
                                title=""
                                onChange={(e) => this.setState({ coupon: e.target.value })}
                                value={this.state.coupon}
                                required
                            />
                        </div>
                        <div >
                            <label htmlFor="title">Pin</label>
                            <input
                                className="form-control"
                                type='text'
                                name="pin"
                                title=""
                                onChange={(e) => this.setState({ pin: e.target.value })}
                                value={this.state.pin}
                                required
                            />
                        </div>
                        <div >
                            <label htmlFor="title">Validity</label>
                            <input
                                className="form-control"
                                type='text'
                                name="validity"
                                title=""
                                onChange={(e) => this.setState({ validity: e.target.value })}
                                value={this.state.validity}
                                required
                            />
                        </div>

                        <div className="mt-2 d-flex justify-content-center">
                            <button
                                type="submit"
                                disabled={!this.state.coupon || !this.state.pin || !this.state.validity}
                                onClick={() => this.handleManualApprove()}
                                className="btn btn-primary mr-3"
                            >
                                Approve
                            </button>
                        </div>
                        <Show when={this.state.status === PageStatus.Submitting}>
                            <div className="d-flex justify-content-center w-100 p-5">
                                <Spinner animation="border" variant="primary" />
                            </div>
                        </Show>

                        <Alert className="mt-3" variant="danger" show={this.state.status === PageStatus.Error}>
                            {this.state.error}
                        </Alert>
                    </div>
                </Modal.Body>
            </Modal>
        );
    }
}

export default ManualApproval;
